// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#vigilance {
  background: #0C0907;
}

.vigilance-text {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.vigilance-text .eyebrow {
  margin-bottom: 20px;
}

.vigilance-h2 {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 8px;
  color: #fff;
}

.vigilance-h2-accent {
  display: block;
  color: #EE5B43;
}

.vigilance-rule {
  width: 40px;
  height: 3px;
  background: #EE5B43;
  border-radius: 2px;
  margin: 20px 0 28px;
}

.vigilance-body {
  font-size: 15.5px;
  line-height: 1.8;
  color: #aebccb;
  margin: 0 0 20px;
}

.vigilance-body:last-of-type {
  margin-bottom: 0;
}

.vigilance-stats {
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  flex-wrap: nowrap;
  margin-top: 36px;
}

.vigilance-stats .istat {
  padding: 18px 30px;
  flex: 1 1;
  min-width: 0;
}

.vigilance-stats .istat .big {
  font-size: 28px;
  color: #EE5B43;
}

.vigilance-stats .istat .l {
  font-size: 11.5px;
  margin-top: 6px;
}

.vigilance-text .eyebrow {
  color: #EE5B43;
}

/* ───────── Responsive : tablette, contenu centré ───────── */
@media (max-width: 768px) {
  .vigilance-h2 {
    font-size: 24px;
  }

  .vigilance-stats {
    flex-wrap: wrap;
  }

  .vigilance-stats .istat {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 8px);
  }

  .vigilance-text {
    align-items: center;
    text-align: center;
  }

  .vigilance-text .eyebrow {
    text-align: center;
  }

  .vigilance-rule {
    margin-left: auto;
    margin-right: auto;
  }

  .vigilance-stats {
    justify-content: center;
  }
}

/* ───────── Responsive : mobile, contenu centré ───────── */
@media (max-width: 480px) {
  .vigilance-text {
    align-items: center;
    text-align: center;
  }

  .vigilance-text .eyebrow {
    text-align: center;
  }

  .vigilance-rule {
    margin-left: auto;
    margin-right: auto;
  }

  .vigilance-stats {
    justify-content: center;
    gap: 10px;
  }

  .vigilance-stats .istat {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 5px);
    padding: 14px 16px;
    text-align: center;
  }
}

@media (max-width: 360px) {
  .vigilance-h2 {
    font-size: 20px;
  }

  .vigilance-body {
    font-size: 14px;
  }

  .vigilance-stats .istat .big {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/VigilanceSection/VigilanceSection.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["#vigilance {\n  background: #0C0907;\n}\n\n.vigilance-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.vigilance-text .eyebrow {\n  margin-bottom: 20px;\n}\n\n.vigilance-h2 {\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 1.25;\n  margin: 0 0 8px;\n  color: #fff;\n}\n\n.vigilance-h2-accent {\n  display: block;\n  color: #EE5B43;\n}\n\n.vigilance-rule {\n  width: 40px;\n  height: 3px;\n  background: #EE5B43;\n  border-radius: 2px;\n  margin: 20px 0 28px;\n}\n\n.vigilance-body {\n  font-size: 15.5px;\n  line-height: 1.8;\n  color: #aebccb;\n  margin: 0 0 20px;\n}\n\n.vigilance-body:last-of-type {\n  margin-bottom: 0;\n}\n\n.vigilance-stats {\n  display: flex;\n  justify-content: flex-start;\n  gap: 16px;\n  flex-wrap: nowrap;\n  margin-top: 36px;\n}\n\n.vigilance-stats .istat {\n  padding: 18px 30px;\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.vigilance-stats .istat .big {\n  font-size: 28px;\n  color: #EE5B43;\n}\n\n.vigilance-stats .istat .l {\n  font-size: 11.5px;\n  margin-top: 6px;\n}\n\n.vigilance-text .eyebrow {\n  color: #EE5B43;\n}\n\n/* ───────── Responsive : tablette, contenu centré ───────── */\n@media (max-width: 768px) {\n  .vigilance-h2 {\n    font-size: 24px;\n  }\n\n  .vigilance-stats {\n    flex-wrap: wrap;\n  }\n\n  .vigilance-stats .istat {\n    flex: 0 0 calc(50% - 8px);\n  }\n\n  .vigilance-text {\n    align-items: center;\n    text-align: center;\n  }\n\n  .vigilance-text .eyebrow {\n    text-align: center;\n  }\n\n  .vigilance-rule {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .vigilance-stats {\n    justify-content: center;\n  }\n}\n\n/* ───────── Responsive : mobile, contenu centré ───────── */\n@media (max-width: 480px) {\n  .vigilance-text {\n    align-items: center;\n    text-align: center;\n  }\n\n  .vigilance-text .eyebrow {\n    text-align: center;\n  }\n\n  .vigilance-rule {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .vigilance-stats {\n    justify-content: center;\n    gap: 10px;\n  }\n\n  .vigilance-stats .istat {\n    flex: 0 0 calc(50% - 5px);\n    padding: 14px 16px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 360px) {\n  .vigilance-h2 {\n    font-size: 20px;\n  }\n\n  .vigilance-body {\n    font-size: 14px;\n  }\n\n  .vigilance-stats .istat .big {\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
